import type { Component } from 'vue';
import type { GlobalFieldId } from '#layers/data-model/public';
import { createContext } from 'reka-ui';

interface ListingContext {
	setDisplayOptionsComponent: (component: Component | null) => void;
	addFieldFilter?: (fieldPath: GlobalFieldId[]) => void;
}

export const [injectListingContext, provideListingContext] = createContext<ListingContext>('Listing');
